import "./step1.css";
import DateSelector from "./components/DateSelector";
import { Room } from "./HotelBookingPage";

interface Step1V2Props {
  onNext: () => void;
  checkIn: Date | null;
  checkOut: Date | null;
  setCheckIn: (date: Date | null) => void;
  setCheckOut: (date: Date | null) => void;
  selectedRoom: Room | null;
  setSelectedRoom: (room: Room) => void;
  roomOptions: Room[];
  isLoadingRooms?: boolean;
}

const Step1V2: React.FC<Step1V2Props> = ({
  onNext,
  checkIn,
  checkOut,
  setCheckIn,
  setCheckOut,
  selectedRoom,
  setSelectedRoom,
  roomOptions,
  isLoadingRooms,
}) => {
  const isMobile = window.innerWidth <= 768;
  const normalize = (d: Date) =>
    new Date(d.getFullYear(), d.getMonth(), d.getDate());

  const checkInValid =
    !!checkIn &&
    normalize(checkIn) >= new Date(2025, 10, 13) &&
    normalize(checkIn) <= new Date(2025, 10, 16);
  const checkOutValid =
    !checkOut || normalize(checkOut) <= new Date(2025, 10, 17);
  const isAvailableDateValid = checkInValid && checkOutValid;

  const isLimitedRoom = (room: Room) =>
    ["King Deluxe Suite", "King Executive Suite"].includes(room.name);

  const limitedRooms = roomOptions.filter(isLimitedRoom);
  const allRooms = [...roomOptions];

  const isNextButtonEnabled =
    selectedRoom !== null && checkIn !== null && checkOut !== null;
  // && // Check if checkOut is also not null
  // (isAvailableDateValid &&  selectedRoom && ["King Deluxe Suite", "King Executive Suite"].includes(selectedRoom.name));

  return (
    <div className="step-content-container">
      <div className="date-picker-row">
        <DateSelector
          checkIn={checkIn}
          checkOut={checkOut}
          setCheckIn={setCheckIn}
          setCheckOut={setCheckOut}
          selectedRoom={selectedRoom}
        />

        <div className="extend-stay-info">
          <p className="extend-question">
            <strong style={{ color: "#F0B429", fontSize: 22 }}>
              Need to Extend Your Stay?
            </strong>
          </p>
          <p className="extend-message">
            Planning to arrive before{" "}
            <strong className="date-strong">12th November 2025</strong> or stay
            beyond <strong className="date-strong">18th November 2025</strong>{" "}
            at Conrad Dubai?
            <br />
            Please reach out to us directly at&nbsp;
            <a href="mailto:accommodation@uaefma.com">
              accommodation@uaefma.com
            </a>{" "}
            or&nbsp;
            <a href="mailto:imukhtar@altayer-travel.com">
              imukhtar@altayer-travel.com
            </a>
            .
          </p>
        </div>
      </div>

      <div className="room-cards-grid">
        {isLoadingRooms ? (
          <div className="dot-loader">
            <span></span>
          </div>
        ) : (
          <>
            {limitedRooms.length > 0 && !isMobile && (
              <div className="availability-banner-hug full-width-banner">
                Available for booking between Nov 13 – 16 only
              </div>
            )}

            {allRooms.map((room) => {
              const isLimited = isLimitedRoom(room);
              const isSoldOut = room.soldOut;
              const isSelected = selectedRoom?.key === room.key;
              const shouldDisable =
                isSoldOut || (isLimited && !isAvailableDateValid);

              return (
                <div
                  className={`room-card ${isSelected ? "selected" : ""} ${
                    shouldDisable ? "disabled" : ""
                  }`}
                  key={room.key}
                  onClick={() => {
                    if (!shouldDisable) setSelectedRoom(room);
                  }}
                >
                  <div className="image-wrapper">
                    {(room.limitSingle != null || room.limitDouble != null) && (
                      <div className="badge-row">
                        <span className="badge limited">
                          {isSoldOut ? "Sold out" : "Limited Slots"}
                        </span>
                      </div>
                    )}
                    <img src={room.image} alt={room.name} />
                  </div>
                  <div className="content">
                    <h3>{room.name}</h3>
                    {isMobile && isLimited && (
                      <p className="note" style={{ color: "#002C2C" }}>
                        Available for booking between Nov 13 – 16 only
                      </p>
                    )}
                    <div className="prices">
                      <div className="price-row">
                        <span>Single Occupancy</span>
                        <span className="price">${room.single.toFixed(2)}</span>
                      </div>
                      <div className="price-row">
                        <span>Double Occupancy</span>
                        <span className="price">${room.double.toFixed(2)}</span>
                      </div>
                    </div>
                    <p className="note">
                      All rates include breakfast and applicable taxes.
                    </p>
                  </div>
                </div>
              );
            })}
          </>
        )}
      </div>

      <p className="final-note">
        Final confirmation will be emailed after submission.
      </p>

      <div className="next-button inline" style={{ backgroundColor: "#fff" }}>
        <button onClick={onNext} disabled={!isNextButtonEnabled}>
          Next: Guest Details
        </button>
      </div>

      <div className="floating-next-button">
        <button onClick={onNext} disabled={!isNextButtonEnabled}>
          Next: Guest Details
        </button>
      </div>
    </div>
  );
};

export default Step1V2;
